module.exports = __webpack_public_path__ + "static/media/AntarcticaBeta-ExtraCondMed.8606332f.ttf";